export default "__VITE_ASSET__z1dkU77q__"